import { call } from "../clients/internalClient";
import { Events } from "../events";


export async function uploadImagesAndInsertAsContent(editor, documentId, images) {

  try {

    const formData = new FormData();
    formData.append('documentId', documentId); // whatever ID you're using
    images.forEach(img => formData.append('images', img));
  
    const {urls, exceedQuota} = await call('POST', '/api/images/upload', formData)

    if (exceedQuota) {
      Events.dispatch(Events.TOAST, {
        text: 'You’ve exceeded your storage quota.',
        kind: 'error'
      })    
    }

    for (let url of urls) {
      if (url) {
        editor.commands.insertContent({
          type: 'image',
          attrs: {
            src: url,
          },
        })
      }
    }
  } catch (err) {
    console.error('Error uploading image:', err)
  }
  
}
